// MP Talep durum senkronizasyonu (tarayici tarafi guvenlik agi).
//
// Sorun: VM kurulumu dakikalar surer; kullanici bu sirada sekmeyi kapatir ya da
// sayfayi yenilerse deploy sonucunu cs-portal'a bildirecek kimse kalmaz ve talep
// "Bekliyor"da takili kalir.
//
// Cozum: deploy baslarken bekleyen is (talep id + CloudStack job id) localStorage'a
// yazilir. cs-ui her acilista ve acikken dakikada bir, kullanicinin KENDI oturumuyla
// queryAsyncJobResult sorar; is bittiyse sonucu (deployed/failed) cs-portal'a isler
// ve kaydi listeden dusurur. API key gerekmez.
import axios from 'axios'
import { getAPI } from '@/api'
import { csPortalApi } from '@/utils/csPortal'

const STORAGE_KEY = 'cs.mpPendingRequests'
const MAX_AGE_MS = 48 * 60 * 60 * 1000 // 48 saatten eski kayitlar birakilir (job CloudStack'te coktan silinmistir)
const POLL_INTERVAL_MS = 60 * 1000

function readEntries () {
  try {
    const list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
    return Array.isArray(list) ? list : []
  } catch (e) {
    return []
  }
}

function writeEntries (list) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list))
  } catch (e) { /* storage dolu/kapali ise sessizce gec */ }
}

export function addPendingMpRequest (requestId, jobId) {
  if (!requestId || !jobId) return
  const list = readEntries().filter(e => e.id !== requestId)
  list.push({ id: requestId, jobId, ts: Date.now() })
  writeEntries(list)
}

export function removePendingMpRequest (requestId) {
  writeEntries(readEntries().filter(e => e.id !== requestId))
}

let syncing = false

export async function reconcilePendingMpRequests () {
  if (syncing) return
  const entries = readEntries()
  if (!entries.length) return
  syncing = true
  try {
    for (const entry of entries) {
      if (!entry.id || !entry.jobId || (entry.ts && Date.now() - entry.ts > MAX_AGE_MS)) {
        removePendingMpRequest(entry.id)
        continue
      }
      try {
        const res = await getAPI('queryAsyncJobResult', { jobid: entry.jobId })
        const job = res && res.queryasyncjobresultresponse
        if (!job) continue
        const status = Number(job.jobstatus)
        if (status === 1) {
          const vmId = (job.jobresult && job.jobresult.virtualmachine && job.jobresult.virtualmachine.id) || null
          await axios.put(`${csPortalApi()}/marketplace/requests/${entry.id}/status`, {
            status: 'deployed',
            cloudstack_vm_id: vmId
          })
          removePendingMpRequest(entry.id)
        } else if (status === 2) {
          const jr = job.jobresult || {}
          await axios.put(`${csPortalApi()}/marketplace/requests/${entry.id}/status`, {
            status: 'failed',
            error_message: String(jr.errortext || jr.errorcode || 'CloudStack job başarısız')
          })
          removePendingMpRequest(entry.id)
        }
        // jobstatus 0: hala calisiyor — bir sonraki tura birak
      } catch (e) {
        // Oturum yok (401), gecici ag hatasi veya job artik sorgulanamiyor:
        // kaydi tutmaya devam et, sonraki turda / sonraki aciliste tekrar dene.
        // Talep cs-portal'dan silindiyse (404) kaydi dusur.
        const st = e && e.response && e.response.status
        const url = (e && e.config && e.config.url) || ''
        if (st === 404 && url.indexOf('/marketplace/requests/') !== -1) {
          removePendingMpRequest(entry.id)
        }
      }
    }
  } finally {
    syncing = false
  }
}

let timer = null

export function startMpRequestSync () {
  if (timer) return
  // Acilista kisa bir gecikmeyle (oturum/config otursun), sonra dakikada bir
  setTimeout(reconcilePendingMpRequests, 5000)
  timer = setInterval(reconcilePendingMpRequests, POLL_INTERVAL_MS)
}
